module.exports = {
  permissionLevels: {
    NORMAL_USER: 1,
    PAID_USER: 4,
    ADMIN: 2048
  },
  a: {aa: 12334},
  b: {
    NORMAL_USER: 1,
    PAID_USER: 4,
    ADMIN: 2048
  },
  // getTyoe: function(){
  //   return console.log(Object.keys(permissionLevels))
  // }
};
